import { Pipe, PipeTransform } from '@angular/core';
import format from 'date-fns/format';

@Pipe({
  name: 'timeFormat',
})
export class TimeFormatPipe implements PipeTransform {
  transform(value: string): any {
    const newValue = value.replace(/am/g, '').replace(/pm/g, '').split(':');
    const [hour, minutes] = newValue;

    // When formatted data gets passed in just pass it back out
    if (newValue.length === 1) {
      return value;
    }

    let formattedHours = parseInt(hour);
    const formattedMinutes = parseInt(minutes) === 0 ? '' : `:${minutes}`;
    const suffix = formattedHours >= 12 ? 'pm' : 'am';

    if (formattedHours > 12) {
      formattedHours = formattedHours - 12;
    }

    return `${formattedHours}${formattedMinutes}${suffix}`;
  }
}

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string, formatString: string = 'EEEE do MMMM'): any {
    // return 'test';
    return format(new Date(value), formatString);
  }
}
